// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2eHtS","right":"styles_right__118Vj"};